import clsx from 'clsx';
import { type FC, useId } from 'react';
import type { ColorPickerProps } from '../../types';

const ColorPicker: FC<ColorPickerProps> = ({
  selectedValue,
  colorOptions,
  isLoading,
  onChange,
}) => {
  const colorPickerLabelId = useId();
  const radioGroupName = useId();

  return (
    <>
      <div className="schedule-meeting-modal__divider" />
      <div className="schedule-meeting-modal__color-picker-section">
        <div className="schedule-meeting-modal__input-label" id={colorPickerLabelId}>
          Pick meeting color
        </div>
        {isLoading && <div className="schedule-meeting-modal__input-hint">Loading colors...</div>}
        <div
          role="radiogroup"
          className="schedule-meeting-modal__color-grid"
          aria-labelledby={colorPickerLabelId}
        >
          {!isLoading && colorOptions.length === 0 && (
            <div className="schedule-meeting-modal__input-hint">No provider colors available.</div>
          )}
          {colorOptions.map((color) => (
            <label
              key={color.id.length > 0 ? color.id : 'no-calendar-color'}
              className="schedule-meeting-modal__color-label"
              title={color.label}
            >
              <input
                type="radio"
                name={radioGroupName}
                value={color.id}
                checked={selectedValue === color.id}
                onChange={() => onChange(color.id)}
                className="schedule-meeting-modal__visually-hidden"
              />
              <div
                className={clsx('schedule-meeting-modal__color-option', {
                  'schedule-meeting-modal__color-option--selected': selectedValue === color.id,
                })}
                style={{ background: color.hexColor }}
              />
            </label>
          ))}
        </div>
      </div>
    </>
  );
};

export default ColorPicker;
